import { render, staticRenderFns } from "./EventPromotion.vue?vue&type=template&id=eeba374a&lang=pug&"
import script from "./EventPromotion.vue?vue&type=script&lang=ts&"
export * from "./EventPromotion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports